import { useState } from 'react';

const examples = [
  {
    title: '对齐报告',
    description: '平台流水、收款、报关、开票四流自动对齐，差异项标红留痕',
    image: 'https://public.readdy.ai/ai/img_res/78f2fa455c3cfc471fe085d8e9cd0957.jpg'
  },
  {
    title: '核销清单',
    description: '按票固化单单对应关系，订单、出库、物流、收款、报关、发票一目了然',
    image: 'https://readdy.ai/api/search-image?query=Tax%20verification%20checklist%20interface%20showing%20document-to-document%20correspondence%20tracking%20order%20warehouse%20logistics%20payment%20customs%20invoice%20relationship%20professional%20compliance%20software%20clean%20organized%20layout%20with%20status%20indicators&width=700&height=450&seq=verification-checklist-v2&orientation=landscape'
  },
  {
    title: '归档包目录',
    description: '一键生成归档包，同一票的关键材料可追溯、随叫随到',
    image: 'https://readdy.ai/api/search-image?query=Organized%20archive%20directory%20interface%20with%20hierarchical%20folder%20structure%20document%20management%20system%20showing%20categorized%20files%20with%20icons%20professional%20file%20organization%20UI%20clean%20layout%20with%20search%20functionality%20and%20export%20options&width=700&height=450&seq=example4&orientation=landscape'
  },
  {
    title: '账务批次追踪',
    description: '收入成本税费按批次/票号自动落账，每一笔都拿得出、说得清',
    image: 'https://readdy.ai/api/search-image?query=Accounting%20batch%20tracking%20system%20showing%20revenue%20cost%20and%20tax%20allocation%20by%20batch%20number%20and%20ticket%20number%20detailed%20financial%20records%20with%20traceability%20professional%20bookkeeping%20software%20interface%20clean%20data%20visualization&width=700&height=450&seq=accounting-batch-v2&orientation=landscape'
  }
];

export default function ExampleModal() {
  const [activeTab, setActiveTab] = useState(0);

  const closeModal = () => {
    const modal = document.getElementById('example-modal');
    if (modal) modal.classList.add('hidden');
  };

  return (
    <div
      id="example-modal"
      className="fixed inset-0 bg-black/60 z-50 hidden flex items-center justify-center p-4"
      onClick={closeModal}
    >
      <div
        className="bg-white rounded-3xl shadow-2xl w-full max-w-[900px] max-h-[700px] overflow-hidden"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Tabs */}
        <div className="bg-gray-50 flex border-b border-gray-200">
          {examples.map((example, index) => (
            <button
              key={index}
              data-tab={index}
              onClick={() => setActiveTab(index)}
              className={`flex-1 px-6 py-4 text-sm font-medium transition-all cursor-pointer whitespace-nowrap ${
                activeTab === index
                  ? 'bg-white text-[#14B8A6] border-b-2 border-[#14B8A6]'
                  : 'text-gray-600 hover:bg-gray-100'
              }`}
            >
              {example.title}
            </button>
          ))}
        </div>

        {/* Content */}
        <div className="p-8 overflow-y-auto max-h-[580px]">
          <h3 className="text-2xl font-bold text-gray-800 mb-3">
            {examples[activeTab].title}
          </h3>
          <p className="text-gray-600 mb-6">
            {examples[activeTab].description}
          </p>
          <div className="w-full h-[400px] bg-gray-50 rounded-2xl overflow-hidden shadow-lg">
            <img
              src={examples[activeTab].image}
              alt={examples[activeTab].title}
              className="w-full h-full object-cover object-top"
            />
          </div>
        </div>

        {/* Close Button */}
        <button
          onClick={closeModal}
          className="absolute top-4 right-4 w-10 h-10 rounded-full bg-gray-200 hover:bg-gray-300 flex items-center justify-center transition-colors cursor-pointer"
        >
          <i className="ri-close-line text-xl text-gray-600"></i>
        </button>
      </div>
    </div>
  );
}
